<template>
    <div id="direct-finance" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
        <!--=====================================-->
        <!--=        DirectFinance Area Start     =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="section-heading heading-left">
                    <span class="subtitle primary">¿Cómo vamos a detonar capital para impulsar el desarrollo sostenible?</span>
                    <div class="row">
                        <div class="col-9">
                            <h2 class="font-weight-100">
                                Contamos con <span class="bold">cuatro estrategias</span> 
                                para movilizar capital sostenible.
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>

export default {
    name: "DirectFinance",
    components: {
    }
}

</script>

<style scoped></style>